import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="font-display font-black text-2xl sm:text-3xl text-black mb-4 tracking-tight">
      {title}
    </h2>
    <div className="font-body text-base text-black/75 leading-relaxed space-y-3">
      {children}
    </div>
  </section>
);

const PaymentPolicyPage = () => (
  <main data-testid="payment-policy-page" className="min-h-screen bg-brand-cream px-6 py-14 md:py-20">
    <div className="max-w-3xl mx-auto">
      <Link to="/" className="inline-flex items-center gap-2 font-display font-black text-xs uppercase tracking-[0.24em] text-black/60 hover:text-black mb-8">
        ← Back to Shirt Happens
      </Link>

      <div className="mb-2 font-display font-black text-[11px] tracking-[0.32em] uppercase text-brand-orange">
        The fine print
      </div>
      <h1 className="font-display font-black text-5xl sm:text-6xl leading-[0.95] text-black tracking-tight mb-6">
        Payment Policy
      </h1>
      <p className="font-body text-base sm:text-lg text-black/70 leading-relaxed mb-12">
        At Shirt Happens Studio, every order is custom made specifically for you. To ensure a smooth production process, please review our payment policy below.
      </p>

      <Section title="Orders Under $100">
        <p>Full payment is required before production begins.</p>
      </Section>

      <Section title="Orders Over $100">
        <p>A 50% deposit is required before artwork creation, material ordering, or production begins.</p>
        <p>The remaining balance is due before pickup, local delivery, or shipment.</p>
      </Section>

      <Section title="Deposits">
        <p>Because every order is custom made, all deposits are <strong className="text-black">non-refundable</strong> once the customer has approved the final artwork and Shirt Happens Studio has ordered materials or begun production.</p>
      </Section>

      <Section title="Artwork Approval">
        <p>Every order includes one digital proof for approval.</p>
        <p>Production will not begin until the customer has approved the final artwork.</p>
        <p>Please carefully review all <strong className="text-black">names, dates, spelling, grammar, colors, sizing, and design placement</strong> before approving your proof.</p>
        <p>Once artwork has been approved, Shirt Happens Studio is not responsible for errors that were approved by the customer.</p>
      </Section>

      <Section title="Custom Artwork">
        <p>Simple text layouts and minor artwork adjustments are included with your order.</p>
        <p>Original custom artwork created from scratch may require an additional design fee based on the complexity of the project. Any design fee will always be discussed and approved before work begins.</p>
      </Section>

      <Section title="Order Changes &amp; Cancellations">
        <p>Changes may be requested before artwork approval.</p>
        <p>After artwork has been approved, additional design changes may result in additional design fees and may affect your turnaround time.</p>
        <p><strong className="text-black">No changes or cancellations may be made once production has begun.</strong></p>
        <p>Any exception is solely at the discretion of Shirt Happens Studio and will require payment for any additional materials, DTF transfers, garments, labor, and production costs incurred.</p>
      </Section>

      <Section title="Sales Tax">
        <p>Applicable Texas sales tax (8.25%) will be added to all taxable orders.</p>
      </Section>

      <Section title="Accepted Payment Methods">
        <ul className="grid grid-cols-2 gap-y-2 pt-1 list-none">
          {['Cash', 'Credit &amp; Debit Cards', 'Stripe', 'Square', 'Apple Pay', 'Cash App'].map((m) => (
            <li key={m} className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-orange" />
              <span dangerouslySetInnerHTML={{ __html: m }} />
            </li>
          ))}
        </ul>
      </Section>

      <div className="mt-16 p-8 rounded-3xl border-2 border-black bg-white shadow-[8px_8px_0_#FF6600] text-center">
        <div className="font-display font-black text-2xl text-black mb-2">Thank you for choosing Shirt Happens Studio.</div>
        <div className="font-display font-black text-lg text-brand-orange tracking-tight">
          From Idea to Shirt. We Make Shirt Happen.
        </div>
        <Link to="/#custom" className="mt-6 inline-flex items-center gap-2 font-display font-black text-xs uppercase tracking-[0.24em] px-6 py-3 rounded-full bg-black text-brand-orange border-2 border-black hover:bg-brand-orange hover:text-black transition-colors">
          Start a shirt →
        </Link>
      </div>
    </div>
  </main>
);

export default PaymentPolicyPage;
